import block from './block.json';

export const cardRoleThemeAttributes = {
	role: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.caption',
		textAlignment: 'left',
	},
	name: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.heading-2',
		textAlignment: 'left',
	},
};

export const CardRoleThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: cardRoleThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
